import { render } from "./PreadmissionNotesForm.vue?vue&type=template&id=8b2ce2c6&ts=true"
import script from "./PreadmissionNotesForm.ts?vue&type=script&lang=ts&external"
export * from "./PreadmissionNotesForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__